const initialData = {
  isLoading: false,
  statisticsData: [],
};

export default function admin(state = initialData, action) {
  switch (action.type) {
    case "GET_STATISTICS_REGISTRATIONS_REQUEST":
      return {
        ...state,
        isLoading: true,
      };
    case "GET_STATISTICS_REGISTRATIONS_SUCCESS":
      return {
        ...state,
        statisticsData: action.payload,
        isLoading: false,
      };
    case "GET_STATISTICS_REGISTRATIONS_FAILED":
      return {
        ...state,
        statisticsData: [],
        isLoading: false,
      };

    default:
      return {
        ...state,
      };
  }
}
